import physios from '../../api/physios'
import patients from "../../api/patients";

const errors = {
    GET_ALL_PHYSIOS_LOADING_ERROR: 'Erreur lors du chargement des physiothérapeutes, merci de réessayer',
    GET_PHYSIO_LOADING_ERROR: 'Erreur lors du chargement du physiothérapeute, merci de réessayer',
    CREATE_PHYSIO_ERROR: 'Erreur lors de la création du physiothérapeute, merci de réessayer',
    UPDATE_PHYSIO_ERROR: 'Erreur lors de la mise à jour du physiothérapeute, merci de réessayer',
}

const success = {
    CREATE_PHYSIO_SUCCESS: {
        title: "Succès",
        content: "Physiothérapeute créé avec succès"
    },
    UPDATE_PHYSIO_SUCCESS: {
        title: "Succès",
        content: "Physiothérapeute mis à jour"
    }
}


// initial state
const state = {
    all: [],
    selectedPhysio: {
        id: null,
        name: '',
        address: '',
        phone: '',
        email: '',
        postcode: '',
        city: '',
        country: 'Suisse',
    },
    form: {
        name: '',
        address: '',
        phone: '',
        email: '',
        postcode: '',
        city: '',
        country: 'Suisse',
    },
}

// getters
const getters = {
}

// actions
const actions = {
    getAllPhysios ({ state, commit, rootState }) {
        physios.getPhysios(rootState.axios).then(result => {
            commit('setPhysios', result.data.physios)
        }).catch(reason => {
            commit('notifications/showError', {
                title: errors.GET_ALL_PHYSIOS_LOADING_ERROR, content: reason
            }, { root: true })

        })
    },

    loadPhysioForm({ state, commit, rootState }) {
        physios.get(state.selectedPhysio.id, rootState.axios).then(result => {
            commit('initPhysioForms', result.data.physio)
        }).catch(reason => {
            commit('notifications/showError', {
                title: errors.GET_PHYSIO_LOADING_ERROR, content: reason
            }, { root: true })

        })
    },

    createPhysio({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            physios.add(state.form, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: success.CREATE_PHYSIO_SUCCESS.title, content: success.CREATE_PHYSIO_SUCCESS.content
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.CREATE_PHYSIO_ERROR, content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },

    updatePhysio({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            physios.update(state.selectedPhysio.id, state.form, rootState.axios).then(result => {
                commit('setSelectedPhysio', result.data.physio)
                commit('notifications/showSuccess', {
                    title: success.UPDATE_PHYSIO_SUCCESS.title, content: success.UPDATE_PHYSIO_SUCCESS.content
                }, { root: true })

                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.UPDATE_PHYSIO_ERROR, content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },

    postDeletePhysio({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            physios.delete(state.selectedPhysio.id, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: success.UPDATE_PHYSIO_SUCCESS.title, content: success.UPDATE_PHYSIO_SUCCESS.content
                }, { root: true })

                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.UPDATE_PHYSIO_ERROR, content: reason.response.data.message
                }, { root: true })
                reject(reason)
            })
        });
    },
}

// mutations
const mutations = {
    setPhysios (state, physios) {
        state.all = physios
    },
    setFormName (state, value) {
        state.form.name = value
    },
    setFormEmail (state, value) {
        state.form.email = value
    },
    setFormPhone (state, value) {
        state.form.phone = value
    },
    setFormAddress (state, value) {
        state.form.address = value
    },
    setFormPostcode (state, value) {
        state.form.postcode = value
    },
    setFormCity (state, value) {
        state.form.city = value
    },
    setFormCountry (state, value) {
        state.form.country = value
    },
    setSelectedPhysio(state, value) {
        state.selectedPhysio = value
    },
    setSelectedPhysioId(state, value) {
        state.selectedPhysio.id = value
    },
    initPhysioForms(state, data) {
        state.form.name = data.name
        state.form.email = data.email
        state.form.phone = data.phone
        state.form.address = data.address
        state.form.city = data.city
        state.form.country = data.country
        state.form.postcode = data.postcode
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
